const convertLabelsToTranslate = (data) => {
  if (!Array.isArray(data)) return {};

  return data.reduce((acc, item) => {
    acc[item.label] = item.value;
    acc[item.label.charAt(0).toUpperCase() + item.label.slice(1)] = item.value;
    acc[item.label.toUpperCase()] = item.value;
    acc[item.label.toLowerCase()] = item.value;
    return acc;
  }, {});
};

const labelsTranslate = () => {
  const dataTranslate = ['Agregado', 'Implemento', 'Caminhão', 'Moto', 'Carro'];
  return dataTranslate.map((item) => ({
    [item]: item,
    [item.toUpperCase()]: item.toUpperCase(),
    [item.toLowerCase()]: item.toLowerCase(),
  }));
};

export { convertLabelsToTranslate, labelsTranslate };
